import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M15 19h-10a2 2 0 0 1 -2 -2v-10a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v5.5","key":"svg-0"}],["path",{"d":"M3 7l9 6l9 -6","key":"svg-1"}],["path",{"d":"M19 16v3","key":"svg-2"}],["path",{"d":"M19 22v.01","key":"svg-3"}]]

const IconMailExclamation = createReactComponent('outline', 'mail-exclamation', 'MailExclamation', __iconNode);

export default IconMailExclamation;